import Toast from 'bootstrap/js/dist/toast';

(function () {
    const toastElList = document.querySelectorAll('.toast');
    const toastList = [...toastElList].map((toastEl) => new Toast(toastEl).show());
})();
